import Color from '@/Enums/Color.enum';
import { Box, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import RemoveButton from './RemoveButton';

interface IProps {
  groupIndex: number;
  label?: string;
  onRemove: (index: number) => void;
}

const AndGroupButton = memo(({ groupIndex, onRemove, label = 'AND' }: IProps) => {
  const onClick = useCallback(() => onRemove(groupIndex), [onRemove, groupIndex]);

  return (
    <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center', justifyContent: 'center' }}>
      <Typography component='p' sx={{ color: Color.Primary, fontSize: '14px', fontWeight: 600 }}>
        {label}
      </Typography>
      <RemoveButton onClick={onClick} />
    </Box>
  );
});

export default AndGroupButton;
